<div *ngIf="purchasedProducts?.length" class="p-4 bg-white rounded-3 mobile-pd">
  <!-- <div class="title-header">
    <div class="d-flex align-wishlist-center w-100">
      <div class="input-group align-wishlist-center border div-search">
        <input id="quiclSearchInput" type="search" class="form-control border-0 bg-transparent search-input"
          placeholder="Bạn đang tìm sản phẩm gì?" [(ngModel)]="inputText" (keyup)="input()" />
        <i class="ri-search-line d-flex justify-content-center align-items-center search-icon"></i>
      </div>
    </div>
  </div> -->
  <h3 class="fw-bold mb-3">Sản phẩm đã mua</h3>
  <div>
    <div class="d-flex flex-column gap-3">
      <app-product-box-vertical
        *ngFor="let item of purchasedProducts"
        class="w-100"
        [product]="item"
      ></app-product-box-vertical>
    </div>
    <div class="text-center my-3" *ngIf="isLoading && purchasedProducts.length > 0">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="text-center my-3 text-muted" *ngIf="purchasedProducts.length < totalItems && !isLoading">
      Kéo xuống để xem thêm
    </div>
    <app-collection-paginate> </app-collection-paginate>
  </div>
</div>
<app-no-data [class]="'no-data-added'" [image]="'assets/svg/empty-items.svg'" [text]="'Bạn chưa có sản phẩm đã mua!'"
  [description]="'Hãy mua sản phẩm để xem danh sách nhé!'" *ngIf="!purchasedProducts.length && !isLoading">
</app-no-data>
